import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {NavComponent} from './nav/nav.component';
import {Button} from 'primeng/button';
import {Menubar} from 'primeng/menubar';
import {PanelMenu} from 'primeng/panelmenu';
import {Drawer} from 'primeng/drawer';
import {AppRoutingModule} from './app-routing.module';
import {ExamplePageComponent} from './example-page/example-page.component';
import {Toast} from 'primeng/toast';
import {NotFoundComponent} from './not-found/not-found.component';
import {MessageService} from 'primeng/api';
import {VehiclesComponent} from './vehicles/vehicles.component';

import {HttpClientModule} from '@angular/common/http';
import {MatTabsModule} from '@angular/material/tabs';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PaymentEstimationWindowComponent} from './paymentestimationwindow/payment-estimation-window.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';
import {VehicleSliceComponent} from './vehicleslice/vehicle-slice.component';
import {DisclosureComponent} from './tooltip/disclosure/disclosure.component'
import {MatFormFieldModule} from '@angular/material/form-field';
import {Tabs} from 'primeng/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CurrencyPipe} from './pipes/CurrencyPipe';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NumbersOnlyDirective} from "./validation/numbers-only.directive";
import {NumbersDollarOnlyDirective} from "./validation/numbers-dollar-only.directive";
import {UserRateValidatorDirective} from "./validation/user-rate-validator";
import {FormatStringPipe} from "./pipes/FormatStringPipe";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {configProvider} from './config/config-initializer';
import {WholeDollarPipe} from "./pipes/WholeDollarPipe";
import {StickyPopoverDirective} from "./popover-directive/sticky-popover.directive";
import {NgbPopoverModule, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {APP_ID} from '@angular/core';

@NgModule({
	declarations: [
		AppComponent,
		NavComponent,
		ExamplePageComponent,
		NotFoundComponent,
		VehiclesComponent,
		PaymentEstimationWindowComponent,
		VehicleSliceComponent,
		DisclosureComponent,
		CurrencyPipe,
		FormatStringPipe,
		NumbersOnlyDirective,
		NumbersDollarOnlyDirective,
		UserRateValidatorDirective,
		WholeDollarPipe,
		StickyPopoverDirective
	],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		CommonModule,
		MatRadioModule,
		BrowserAnimationsModule,
		RouterModule,
		AppRoutingModule,
		Button,
		MatDialogModule,
		Menubar,
		PanelMenu,
		Drawer,
		Toast,
		HttpClientModule,
		Tabs,
		MatTabsModule,
		MatGridListModule,
		MatCardModule,
		MatSidenavModule,
		MatToolbarModule,
		MatListModule,
		MatIconModule,
		MatButtonToggleModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatTooltipModule,
		MatProgressSpinnerModule,
		NgbPopoverModule,
  NgbModule
	],
	providers: [
		MessageService,
		HttpClientModule,
		configProvider,
		{ provide: APP_ID, useValue: 'lincoln-pe-web' }
	],
	exports: [
		UserRateValidatorDirective,
		NumbersOnlyDirective,
		NumbersDollarOnlyDirective
	],
	bootstrap: [AppComponent]
})
export class AppModule {

}
